import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"
import i18n from "i18n"
import { API } from "api"
import { userIdeaRemove } from "./slice"

function* remove({ payload: { id, onSuccess } }) {
  try {
    const response = yield call(API.admin.deleteUserIdea, id)

    const { data } = response

    yield put(userIdeaRemove.removeCompleted())

    toastr.success(i18n.t("remove.success"))

    if (onSuccess) {
      onSuccess()
    }
  } catch (error) {
    const errors = error.response?.data?.errors || {}
    const message = error.response?.data?.message || i18n.t("error")

    yield put(
      userIdeaRemove.removeRejected({
        errors,
        message,
      })
    )
    toastr.error(message)
  }
}

export function* watchRemove() {
  yield takeEvery(userIdeaRemove.remove, remove)
}

function* removeSaga() {
  yield all([fork(watchRemove)])
}

export default removeSaga
